import React from 'react';
import PropTypes from 'prop-types';
import {Trans, translate} from 'react-i18next';
import {Link} from 'react-router-dom';


CookiesView.propTypes = {
  settings: PropTypes.bool,
  applyCookies: PropTypes.func,
  showSettingsCookies: PropTypes.func,
  t: PropTypes.func,
  language: PropTypes.string,
};


function CookiesView(props) {
  const {settings, applyCookies, showSettingsCookies, t, language} = props;
  const settingsText = !settings ? 'cookies_settings': 'cookies_hide_settings';
  const linkPolicy = `/${language}/policy`;
  return (
    <div className='cookies-popup'>
      <Trans i18nKey="cookies_section_1">
        <p>
          This website uses cookies to make your browsing experience easier and more enjoyable.
          <Link target='_blank' to={linkPolicy}>More information</Link>
          <button className='cookies-popup__btn' onClick={applyCookies}>Accept</button>
        </p>
      </Trans>
      <p>
        {t('cookies_section_2')}
        <button className='cookies-popup__btn' onClick={showSettingsCookies}>{t(settingsText)}</button>
      </p>
      <div className='cookies-popup__settings'>
        {settings &&
          <p>
            <input type="checkbox" id="settings" name="settings" checked={true} disabled={true} />
            <label htmlFor="settings">{t('cookies_section_3')}</label><br />
            {t('cookies_section_4')}
          </p>
        }
      </div>
    </div>
  );
}


export default translate('translations')(CookiesView);



// WEBPACK FOOTER //
// ./src/components/App/CookiesView.js